<template>
  <div
    class="slim-cta slim-cta1 slim-cta--1 lp-section width-expand padding-xl-vertical"
    :class="`bg-${backgroundColor}`"
    :id="`SlimCta1-${pageUid}`">
    <div
      class="container container-l padding-xl-vertical flex flex-between gap-l flex-break-column-center">
      <div class="text" style="max-width: 1000px">
        <h2
          :class="`c-${titleColor}`"
          class="text-m text-2xl text-bold c-lead-2 margin-remove-bottom">
          {{ title }}
        </h2>
        <p
          :class="`c-${textColor}`"
          class="margin-remove text-2xl line-height-090">
          {{ text }}
        </p>
        <p
          :class="`c-${bottomTextColor}`"
          class="text-xl text-bold margin-bottom-remove margin-s-top">
          <strong> {{ bottomText }}</strong>
        </p>
      </div>
      <div class="cta flex-column flex-center flex-middle gap-s">
        <form-button
          v-if="button.show"
          v-bind="{ ...button, size: 'l' }"
          @click.prevent="
            track(`slimCta1|button|click`, { value: button.text }).then(
              button.navigationHandler
            )
          "></form-button>
        <div class="cta-link flex gap-s text-l" v-if="iconLink.show">
          <span
            :class="`c-${linkPrefixColor}`"
            v-if="isNonEmptyString(linkPrefix)">
            {{ linkPrefix }}
          </span>
          <a
            :href="iconLink.href"
            class=""
            @click.prevent="
              track(`slimCta1|iconLink|click`, { value: iconLink.text }).then(
                iconLink.navigationHandler
              )
            ">
            <icon-text
              :icon-position="'end'"
              v-bind="iconLink"
              :auto-translate="false">
            </icon-text>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import useUiElements from "@/client/extensions/composition/useUiElements";
import lpSectionMixin from "@/client/applications/meitavlp/extensions/mixins/lpSection";
import { inject } from "vue";

export default {
  mixins: [lpSectionMixin],

  setup(props) {
    let pageUid = inject("pageUid");

    let schema = {
      title: "",
      text: "",
      bottomText: "",
      button: {},
      linkPrefix: "",
      iconLink: {},
      backgroundColor: "",
      titleColor: "",
      textColor: "",
      bottomTextColor: "",
      linkPrefixColor: "",
    };
    let overloadedProps = useUiElements({ input: props.sectionData }).props;
    return {
      ...schema,
      ...overloadedProps,
      allData: overloadedProps,
      pageUid,
      trackEvent: inject("trackEvent"),
      track: inject("track"),
      triggerSectionsEvent: inject("triggerSectionsEvent"),
    };
  },
  data: function () {
    return {};
  },
  computed: {},
  methods: {
    async testMethod() {
      console.log("doing test!", this.trackEvent);
      await utilities.wait(1000);
      console.log("all done with test method");
      return true;
    },
  },
};
</script>

<style scoped lang="scss">
.slim-cta1 {
}
</style>
